import Layout from '@/components/layout';
import NavLink from '../common/NavLink';
import router, { useRouter } from 'next/router';
import clsx from 'clsx';
import AccountDropdown from '../pages/account/AccountDropdown';
import { SEOProps } from '@/lib/seoData';

export interface AccountSection {
  path: 'profile' | 'membership' | 'orders' | 'address-book' | 'preferences';
  title: string;
}

export const SECTIONS: AccountSection[] = [
  { path: 'membership', title: 'Membership' },
  { path: 'profile', title: 'Profile' },
  { path: 'orders', title: 'Order History' },
  { path: 'address-book', title: 'Addresses' },
  // { path: 'preferences', title: 'Preferences' },
];

const AccountLayout = ({ children, seo }: { seo: SEOProps; children: JSX.Element }) => {
  const { pathname } = useRouter()

  async function handleSignOut() {
    fetch('/api/auth/signout', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(() => {
      router.push('/login');
    });
  }

  return (
    <Layout seo={seo}>
      <div className="py-6 px-8 bg-metal h-full flex flex-1">
        <div className="container lg:pt-12 pb-14 flex flex-col lg:flex-row mx-auto text-cloud">
          <AccountDropdown />
          <nav className="w-1/4 hidden lg:block">
            <ul>
              <li className={`my-4`}>
                <NavLink
                  className={clsx('uppercase font-normal', pathname === '/account' && "underline font-semibold")}
                  href={`/account`}
                  exact
                >
                  dashboard
                </NavLink>
              </li>
              {SECTIONS.map((section: AccountSection) => (
                <li key={section.path} className={`my-4`}>
                  <NavLink
                    className="uppercase font-normal"
                    href={`/account/${section.path}`}
                    activeClassName="underline font-semibold"
                  >
                    {section.title}
                  </NavLink>
                </li>
              ))}
              <li className={`my-4`}>
                <a
                  className="uppercase font-normal cursor-pointer"
                  onClick={handleSignOut}
                >
                  Sign Out
                </a>
              </li>
            </ul>
          </nav>
          <section className="lg:w-3/4 w-full">{children}</section>
        </div>
      </div>
    </Layout>
  );
};

export default AccountLayout;
